import axios from 'axios';
import actionHelpers from '../../utils/action-helpers';
import { getCookie } from '../../utils/helpers';

const path = process.env.VUE_APP_ROOT_API;

axios.defaults.baseURL = path;

const state = {
  status: null,
  currentUser: {},
  authenticated: false,
  role: {},
  errors: [],
};

// getters
const getters = {
  isMember: state => state.authenticated && state.user.role_id <= 4,
  isEditor: state => state.authenticated && state.user.role_id <= 2,
  isAdmin: state => state.authenticated && state.user.role_id <= 1,
};

// actions
const actions = {
  RESET_ERRORS: actionHelpers.RESET_ERRORS,
  RESET_STATUS: actionHelpers.RESET_STATUS,
  LOGIN: async ({ commit, dispatch }, { email, password }) => {
    try {
      const { data: { user, token } } = await axios.post(`${path}/api/login`, { email, password });

      if (user) {
        commit('SET_CURRENT_USER', user);
        document.cookie = `token=${token};expires=Fri, 31 Dec 9999 23:59:59 GMT`;
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        dispatch('herdStats/FETCH', { id: user.id }, { root: true });
        dispatch(
          'notification/SUCCESS_NOTIFICATION',
          'You have logged in successfully',
          { root: true }
        );
      }
    } catch (error) {
      commit('SET_ERROR', error);
      dispatch(
        'notification/ERROR_NOTIFICATION',
        'could not login. try again later.',
        { root: true }
      );
    }
  },
  GET_CURRENT_USER: async ({ commit, dispatch }) => {
    try {
      const token = getCookie('token');
      
      if (token) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const {
          data: { user }
        } = await axios.get(`${path}/api/authenticated`);
        
        if (user) {
          commit('SET_CURRENT_USER', user);
          dispatch('herdStats/FETCH', { id: user.id }, { root: true });
        }
      }
    } catch (error) {
      commit('SET_ERROR', error);
      document.cookie = `token=`;
      axios.defaults.headers.common['Authorization'] = '';
    }
  },
  LOGOUT: async ({ commit, dispatch }) => {
    try {
      await axios.post(`${path}/api/logout`);

      commit('LOGOUT_USER');
      dispatch('herdStats/RESET', {}, { root: true });
    } catch (error) {
      if (error && error.response && error.response.status === 419) {
        console.error('the session has expired');
      }
    }
  },
  SET_ERROR: ({ commit }, payload) => {
    commit('SET_ERROR', payload.errors);
  }
};

// mutations
const mutations = {
  RESET: state => {
    state.status = null;
    state.currentUser = {};
    state.authenticated = false;
    state.role = {};
    state.errors = [];
  },
  RESET_ERRORS: state => {
    state.errors = [];
  },
  SET_ERROR: (state, error) => {
    if (typeof error === 'object') {
      state.errors = state.errors.concat(error);
    }
  },
  LOGOUT_USER(state) {
    state.currentUser = {};
    state.authenticated = false;
    state.role = {};
    document.cookie = `token=`;
    axios.defaults.headers.common['Authorization'] = '';
  },
  SET_CURRENT_USER(state, user) {
    state.currentUser = {
      id: user.id,
      role_id: user.role.id,
      username: user.username,
      first_name: user.first_name,
      last_name: user.last_name,
      full_name: user.full_name,
      role_name: user.role.name,
      email: user.email,
      country: user.country,
    };
    state.role = user.role;

    if (state.currentUser.id) {
      state.authenticated = true;
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
